<template>
    <div v-loading="loading" class="container-fluid mt-6 px-5">
        <div class="ms-1">
            <div class="d-flex align-items-center mt-4 mb-3">
                <soft-button class="me-3" color="secondary" @click="goBack">
                    <i class="fa fa-arrow-left"></i>&nbsp;Geri
                </soft-button>
            </div>

            <titles style="margin: 0;" :text="`İcra — Məhkəmə işi №${courtCaseNumber || '—'}`" />

            <div class="d-flex align-items-center">
                <div class="text-muted me-4">
                    <i class="fa fa-user-tie"></i> Məsul şəxs: {{ responsibleName || '—' }}
                </div>
                <div class="text-muted">
                    <i class="fa fa-user me-1"></i> Cavabdeh: {{ participantName || '—' }}
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="card mt-4 shadow-sm">
                    <div class="card-body" style="font-size: 14px; color: #606266;">
                        <div class="d-flex justify-content-between align-items-start mb-0">
                            <titles style="margin: 0;" text="İcra məlumatları" />
                            <div class="d-flex align-items-center">
                                <div v-if="executorMeta.createdBy || executorMeta.updatedBy"
                                    class="record-label-wrapper position-relative" style="margin-right:12px">
                                    <el-button type="default" size="large" text style="padding: 0px;" :icon="InfoFilled"
                                        class="fs-5" />
                                    <div class="record-label-tooltip">
                                        <record-label :created="executorMeta.createdBy"
                                            :updated="executorMeta.updatedBy"
                                            style="color: #606266; font-size: 14px;" />
                                    </div>
                                </div>
                                <el-button class="fs-5" type="text" style="padding: 0px;" :icon="Edit"
                                    title="Düzəliş et" @click="openEditDialog" />
                            </div>
                        </div>
                        <hr style="margin-top: 10px;" />
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row mb-2">
                                    <div class="col-6 font-weight-bold">İcraçı</div>
                                    <div class="col-6">{{ enforcementOfficer || '—' }}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-6 font-weight-bold">Öhdəlik məbləği (AZN)</div>
                                    <div class="col-6">{{ formatAmount(obligationAmount) }}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-6 font-weight-bold">Qeydlər</div>
                                    <div class="col-6">{{ note || '' }}</div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="row mb-2">
                                    <div class="col-5 font-weight-bold">Məsul şəxs</div>
                                    <div class="col-7">{{ responsibleName || '—' }}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-5 font-weight-bold">Əlaqə nömrəsi</div>
                                    <div class="col-7">{{ responsiblePhone || '—' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-4 shadow-sm">
                    <div class="card-body">
                        <titles text="Sənədlər" />
                        <div v-if="docs.length === 0" class="text-muted" style="padding:12px;">Sənəd tapılmadı</div>
                        <div v-for="doc in docs" :key="doc.id" class="mb-4">
                            <div class="doc-header-row">
                                <upload class="upload-root" :sourcetype="1" :source-id="doc.id"
                                    :document-name="doc.documentName" :listtype="'text'" :disabled="false"
                                    :downloadAll="false" @fileUploaded="fetchDocs" :showTrigger="true" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-6 mt-4">
                <Payment :id="subrogationId" :participant="participantId" :agreed-amount="obligationAmount"
                    :source-type="3" @open-invoice-dialog="openInvoiceDialog"
                    @open-invoices-timeline-dialog="openInvoicesTimelineDialog" />
            </div>
        </div>

        <el-dialog v-model="editDialogVisible" title="Redaktə et" width="35%" top="100px">
            <div class="mb-3">
                <label class="form-label">İcraçı</label>
                <el-input v-model="editForm.enforcementOfficer" size="large" />
            </div>
            <div class="mb-3">
                <label class="form-label">Öhdəlik məbləği</label>
                <el-input v-model="editForm.obligationAmount" type="number" size="large" />
            </div>
            <div class="mb-3">
                <label class="form-label">Qeydlər</label>
                <el-input v-model="editForm.note" type="textarea" size="large" rows="3" />
            </div>
            <div class="d-flex justify-content-end mt-4">
                <soft-button type="button" @click="saveEdits">Yadda saxla</soft-button>
                &nbsp;
                <soft-button type="button" color="secondary" @click="editDialogVisible = false">İmtina</soft-button>
            </div>
        </el-dialog>

        <!-- Invoice dialogs -->
        <el-dialog v-model="invoicesTimelineDialog" title="Hesab faktura" width="40%">
            <InvoiceTimeline ref="invoiceTimeline" :participant-id="participantId"
                @close-timeline="invoicesTimelineDialog = false" @open-print="onOpenPrintInvoice" />
        </el-dialog>

        <el-dialog v-model="invoiceDialogVisible" title="Yeni hesab-faktura" width="450px" @open="onInvoiceDialogOpen">
            <InvoiceDialog :participant-id="participantId" :subrogation-id="subrogationId"
                :agreed-amount="obligationAmount" :agreement-expense="0" :show-expense="false" @saved="onInvoiceSaved"
                @cancel="invoiceDialogVisible = false" />
        </el-dialog>

        <el-dialog v-model="invoicePrintDialogVisible" width="60%" center top="4vh">
            <div id="invoice-print-area" ref="printArea" class="print-content">
                <div class="d-flex mb-3">
                    <soft-button id="printButton" v-print="'#invoice-print-area'" color="dark">
                        <i class="fa-solid fa-print"></i>&nbsp;Çap et
                    </soft-button>
                </div>
                <div class="invoice-header">
                    <div class="invoice-title">Hesab-faktura {{ selectedInvoice?.invoiceNumber }}
                    </div>
                </div>
                <div class="invoice-info" style="display: flex; justify-content: space-between;">
                    <div>
                        <div style="font-size:15px"><b>Bank:</b> {{ selectedInvoice?.bankName || '—'
                            }}</div>
                        <div style="font-size:15px"><b>H/h:</b> {{ selectedInvoice?.accountNumber ||
                            '—' }}</div>
                        <div style="font-size:15px"><b>Kod:</b> {{ selectedInvoice?.bankCode || '—'
                            }}</div>
                        <div style="font-size:15px"><b>VÖEN:</b> {{ selectedInvoice?.tin || '—' }}
                        </div>
                        <div style="font-size:15px"><b>M/h:</b> {{ selectedInvoice?.cbAccount || '—'
                            }}
                            <div style="font-size:15px"><b>SWIFT:</b> {{ selectedInvoice?.swift ||
                                '—' }}</div>
                        </div>
                    </div>
                    <div>
                        <div style="font-size:15px"><b>Sığortaçı:</b> ABC Sığorta</div>
                        <div style="font-size:15px"><b>Ünvan:</b> {{ selectedInvoice?.address || '—'
                            }}</div>
                        <div style="font-size:15px"><b>Təqdim olunan (Cavabdeh):</b> {{
                            selectedInvoice?.debtorName +
                            " " + selectedInvoice?.debtorSurname || '—' }}</div>
                        <div v-if="selectedInvoice?.debtorTin" style="font-size:15px">
                            <b>VÖEN/FİN:</b> {{
                                selectedInvoice.debtorTin }}
                        </div>
                        <div style="font-size:15px"><b>Tarix:</b> {{
                            formatDate(selectedInvoice?.createDate) }}</div>
                    </div>
                </div>
                <table class="table table-bordered invoice-table">
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Tələb / Xidmət</th>
                            <th class="text-end">Məbləğ (AZN)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Razılaşdırılmış məbləğ</td>
                            <td class="text-end">{{ formatAmount(selectedInvoice?.agreementAmount)
                                }}</td>
                        </tr>
                        <tr v-if="selectedInvoice?.preAgreementExpense">
                            <td>2</td>
                            <td>Əlavə xərc</td>
                            <td class="text-end">{{
                                formatAmount(selectedInvoice?.preAgreementExpense) }}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td style="font-weight:600; ">Yekun məbləğ</td>
                            <td class="text-end" style="font-weight:600; ">{{
                                formatAmount(selectedInvoice?.totalAmount)
                                }}</td>
                        </tr>

                    </tbody>
                </table>
                <div v-if="selectedInvoice?.payments?.length" class="payment-schedule">
                    <div style="font-size:15px;font-weight:600;margin-bottom:4px">Ödəniş cədvəli
                    </div>
                    <table class="table table-bordered payment-table">
                        <thead>
                            <tr>
                                <th>Tarix</th>
                                <th class="text-end">Məbləğ (AZN)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(p, idx) in selectedInvoice.payments" :key="idx">
                                <td>{{ formatDate2(p.paymentDate) }}</td>
                                <td class="text-end">{{ formatAmount(p.amount) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="invoice-footer" style="display:flex;justify-content:space-between;margin-top:30px">
                    <div>
                        <div style="margin-bottom:18px">___________________________<br />
                            <span style="font-size:13px">Sığorta şirkətinin nümayəndəsi</span>
                        </div>
                    </div>
                    <div>
                        <div style="margin-bottom:18px">___________________________<br />
                            <span style="font-size:13px">Cavabdeh şəxs</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import Payment from "@/project/Components/Payment.vue";
import Titles from "@/project/Components/Titles.vue";
import RecordLabel from "@/project/Components/RecordLabel.vue";
import { GetCourtParticipants, UpdateCourtParticipant } from "@/project/Source/courtparticipants";
import { GetCourtEnforcementsByCourtCase, UpdateEnforcementExecutor } from "@/project/Source/courtenforcements";
import { respUsers } from "@/project/Source/helper";
import { GetCourtDecision } from "@/project/Source/courtdecisions";
import InvoiceDialog from "@/project/Components/Dialogs/InvoiceDialog.vue";
import InvoiceTimeline from "@/project/Components/InvoiceTimeline.vue";
import Upload from "@/project/Components/Upload.vue";
import { GetSubrogationDocs } from "@/project/Source/subrogationdoc";
import { Edit, InfoFilled } from "@element-plus/icons-vue";

export default {
    components: { SoftButton, Payment, Titles, RecordLabel, InvoiceDialog, InvoiceTimeline, Upload },
    data() {
        return {
            Edit, InfoFilled,
            subrogationId: null,
            participantId: null,
            courtCaseId: null,
            courtCaseNumber: null,
            loading: false,
            obligationAmount: null,
            responsibleName: null,
            responsiblePhone: null,
            note: null,
            participantName: null,
            enforcementId: null,
            enforcementOfficer: null,
            executorMeta: { createdBy: null, updatedBy: null },
            editDialogVisible: false,
            editForm: {
                obligationAmount: null,
                note: null,
                participantId: null,
                enforcementId: null
            },
            invoiceDialogVisible: false,
            invoicesTimelineDialog: false,
            decisionAmount: 0,
            docs: [],
            invoicePrintDialogVisible: false,
            selectedInvoice: null
        };
    },
    async mounted() {
        this.subrogationId = this.$route.params.subrogationId;
        this.participantId = this.$route.params.participantId;
        this.courtCaseId = this.$route.query.courtCaseId;

        this.fetchObligationAmount();
        await this.fetchExecutor();
        await this.fetchDocs();
        this.getDecisionAmount();
    },
    methods: {
        onOpenPrintInvoice(invoice) {
            this.selectedInvoice = invoice;
            console.log("Selected invoice for print:", this.selectedInvoice);
            this.invoicesTimelineDialog = false;
            this.$nextTick(() => (this.invoicePrintDialogVisible = true));
        },
        
        formatDate(dateString) {
            if (!dateString) return "-";
            const d = new Date(dateString);
            const dd = String(d.getDate()).padStart(2, "0");
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const yyyy = d.getFullYear();
            const hh = String(d.getHours()).padStart(2, "0");
            const min = String(d.getMinutes()).padStart(2, "0");
            return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
        },

        formatAmount(value) {
            if (value == null) return "-";
            const parts = Number(value).toFixed(2).split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(",");
        },

        formatDate2(dateString) {
            if (!dateString) return "-";
            const d = new Date(dateString);
            const dd = String(d.getDate()).padStart(2, "0");
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const yyyy = d.getFullYear();
            return `${dd}.${mm}.${yyyy}`;
        },

        openInvoiceDialog() { 
            this.invoiceDialogVisible = true; 
        },

        openInvoicesTimelineDialog() { 
            this.invoicesTimelineDialog = true; 
        },

        onInvoiceSaved(invoiceId) {
            this.invoiceDialogVisible = false;
            this.invoicesTimelineDialog = true;
            this.$nextTick(() => {
                if (this.$refs.invoiceTimeline) {
                    this.$refs.invoiceTimeline.openPrint(invoiceId);
                }
            });
        },
        async getDecisionAmount() {
            this.loading = true;
            try {
                const res = await GetCourtDecision(this.courtCaseId);
                this.decisionAmount = res.data.data[0]?.decisionAmount || 0;
            } catch {
                this.decisionAmount = 0;
            } finally {
                this.loading = false;
            }
        },

        openEditDialog() {
            this.editForm.obligationAmount = this.obligationAmount;
            this.editForm.note = this.note;
            this.editForm.participantId = this.participantId;
            this.editForm.enforcementOfficer = (this.enforcementOfficer === '—' ? '' : this.enforcementOfficer) || '';
            this.editDialogVisible = true;
        },

        async saveEdits() {
            if (Number(this.editForm.obligationAmount) > Number(this.decisionAmount)) {
                this.$message.warning("Öhdəlik məbləği qərar məbləğindən çox ola bilməz!");
                return;
            }
            try {
                this.loading = true;

                const res = await GetCourtParticipants(this.courtCaseId);
                const fullParticipant = res.data.data.find(p => p.id === parseInt(this.editForm.participantId));
                if (!fullParticipant) throw new Error("Participant tapılmadı");

                const update1 = UpdateCourtParticipant({
                    ...fullParticipant,
                    obligationAmount: this.editForm.obligationAmount,
                    user: this.$store.state.user.id
                });

                const update2 = UpdateEnforcementExecutor({
                    id: this.editForm.enforcementId,
                    notes: this.editForm.note,
                    enforcementOfficer: this.editForm.enforcementOfficer,
                    user: this.$store.state.user.id
                });


                await Promise.all([update1, update2]);

                this.$message.success("Uğurlu əməliyyat!");
                this.editDialogVisible = false;
                this.fetchObligationAmount();
                this.fetchExecutor();
            } catch (err) {
                console.error("Yenilənmə zamanı xəta:", err);
                this.$message.error("Xəta baş verdi");
            } finally {
                this.loading = false;
            }
        },

        async fetchObligationAmount() {
            try {
                this.loading = true;
                const res = await GetCourtParticipants(this.courtCaseId);
                const participant = res.data.data.find(p => p.id === parseInt(this.participantId));
                this.obligationAmount = participant?.obligationAmount ?? 0;

                if (participant) {
                    this.participantName = participant.personType === 1
                        ? `${participant.name} ${participant.surname}`
                        : participant.name;
                } else {
                    this.participantName = "—";
                }
            } catch (error) {
                console.error("❌ Öhdəlik məlumatı yüklənə bilmədi:", error);
                this.$message.error("Xəta baş verdi!");
            } finally {
                this.loading = false;
            }
        },

        async fetchExecutor() {
            try {
                const res = await GetCourtEnforcementsByCourtCase(this.courtCaseId);
                const enforcement = res.data.data.find(e => e.courtCaseId === parseInt(this.courtCaseId));

                if (!enforcement) {
                    this.responsibleName = "—";
                    this.responsiblePhone = "—";
                    this.note = "";
                    this.courtCaseNumber = "—";
                    this.enforcementOfficer = "—";
                    this.enforcementId = null;
                    this.executorMeta = { createdBy: null, updatedBy: null };
                    return;
                }

                // Məsul şəxs из resp_user_id (или respUserId)
                const respId = enforcement.resp_user_id ?? enforcement.respUserId ?? null;
                const user = respUsers.find(u => u.id === respId);
                this.responsibleName = user?.name || "(tapılmadı)";
                this.responsiblePhone = user?.phone || "—";

                // İcraçı — строка
                this.enforcementOfficer = enforcement?.enforcementOfficer || "—";

                this.note = enforcement?.notes || "";
                this.courtCaseNumber = enforcement?.courtCaseNumber || "—";

                this.executorMeta = {
                    createdBy: enforcement?.createdBy || null,
                    updatedBy: enforcement?.updatedBy || null
                };

                this.enforcementId = enforcement?.id || null;
                this.editForm.enforcementId = this.enforcementId;
            } catch (err) {
                console.error("❌ Enforcement load error:", err);
                this.responsibleName = "(tapılmadı)";
                this.responsiblePhone = "—";
                this.note = "";
                this.enforcementOfficer = "—";
            }
        },

        async fetchDocs() {
            try {
                this.loading = true;
                const res = await GetSubrogationDocs(this.subrogationId, 0, 0, this.enforcementId);
                this.docs = (res.data.data || []).map(doc => {
                    const fileNames = doc.fileName ? doc.fileName.split(",").map(x => x.trim()) : [];
                    const urls = doc.url ? doc.url.split(",").map(x => x.trim()) : [];
                    const files = fileNames.map((name, i) => ({ id: `${doc.id}_${i}`, name, urlorig: urls[i] || "" }));
                    return { ...doc, files };
                });
            } catch {
                this.docs = [];
            } finally {
                this.loading = false;
            }
        },

        goBack() { window.history.back(); }
    }
};
</script>

<style scoped>
.doc-header-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
}

.record-label-wrapper {
    position: relative;
}

.record-label-tooltip {
    display: block;
    position: absolute;
    top: 100%;
    right: 0;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    z-index: 1000;
    min-width: 180px;
    opacity: 0;
    transform: translateY(5px);
    pointer-events: none;
    transition: opacity .3s ease, transform .3s ease;
}

.record-label-wrapper:hover .record-label-tooltip {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
}

.text-muted {
    font-size: 14px;
}

.print-content {
    background: #fff;
    padding: 24px 28px 36px 28px;
    min-height: 440px;
}

.invoice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #606266;
    padding-bottom: 16px;
}

.invoice-title {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
}

.invoice-info {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    margin-bottom: 8px;
}

.invoice-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;
    font-size: 15px;
}

.payment-schedule {
    margin-top: 28px;
}

.payment-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.invoice-footer {
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
}
</style>
